import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPage, { LegalSection } from '../../components/LegalPage/LegalPage';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  const sections = t('privacyPolicy.sections', { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t('privacyPolicy.title')}
      lastUpdated={t('privacyPolicy.lastUpdated')}
      tocLabel={t('legal.tocLabel')}
      backToTopLabel={t('legal.backToTop')}
      sections={sections}
    />
  );
};

export default PrivacyPolicy;
